import {Field} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {motion} from 'motion/react'
import {useFieldContext} from '../../integrations/form/index.js'

const FieldError = motion.create(Field.ErrorText)

function parseTranslationKey(input: unknown) {
  if (typeof input !== 'string') return {namespace: undefined, translationKey: undefined}

  if (!input.includes(':')) return {namespace: 'common', translationKey: input}

  const [namespace, translationKey] = input.split(':')

  return {namespace, translationKey}
}

interface Props {
  errorMessagePadding?: number
  srOnly?: boolean
}

export function ErrorMessage({errorMessagePadding = 0, ...props}: Props) {
  const field = useFieldContext<unknown>()
  const {t} = useTranslate()

  const isInvalid = field.state.meta.errors.length > 0
  const errorMessage = isInvalid ? field.state.meta.errors[0].message : ''
  const {namespace, translationKey} = parseTranslationKey(errorMessage)
  if (isInvalid && errorMessage) {
    return (
      <FieldError
        layout
        initial={{height: errorMessagePadding, opacity: 0}}
        exit={{height: errorMessagePadding, opacity: 0}}
        animate={{height: errorMessagePadding + 10, opacity: 1}}
        {...props}
      >
        {translationKey ? t(translationKey, errorMessage, {ns: namespace}) : errorMessage}
      </FieldError>
    )
  }

  return null
}
